module.exports = __webpack_public_path__ + "static/media/retail-enclosed-mall.51d498b8.svg";